import { render, staticRenderFns } from "./CustomerProfileSection.vue?vue&type=template&id=207abe45&scoped=true&"
import script from "./CustomerProfileSection.vue?vue&type=script&lang=js&"
export * from "./CustomerProfileSection.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProfileSection.vue?vue&type=style&index=0&id=207abe45&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207abe45",
  null
  
)

export default component.exports